import { RoomStatusProps } from "../../../../interfaces/RoomStatusProps.interface"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import Wrapper from "../../shared/Wrapper/Wrapper"
import { useApartadaCountdown } from "../../../../hooks/useApartadaCountdown"

import "../Blocked/Blocked.css"

const Apartada = (props: RoomStatusProps) => {
    const { timeLeft } = useApartadaCountdown(props.dateStatusChanged)

    return (
        <Wrapper bgColor={"var(--card-gray)"}>
            <RoomCardHeader
                hasIncidences={props.hasIncidences}
                iconName={"LockFill"}
                roomNumber={props.roomNumber}
                roomTypeName={props.roomTypeName}
                timeout={props.timeout}
                iconBgColor="var(--bloqueada)"
            />
            <div className="room-card--lg--blocked__body">
                <span className="room-card--lg--blocked__timer">{timeLeft}</span>
                <div className="room-card--lg--blocked__descripcion-wrapper">
                    <div className="room-card--lg--blocked__descripcion">
                        <span className="room-card--lg--blocked__descripcion-text">Habitación apartada</span>
                    </div>
                </div>
            </div>
        </Wrapper>
    )
}

export default Apartada
